import { MSCalendar } from "../..";
import styles from "../styles.css";
import { IExclude } from "@lib/store/src/calendar";

import { ExceptionModal } from "./exception";
import { getEditEventExceptionTemplate } from "./edit-event-exception.templates";
import { UiFloatPopover } from "../../../common/popover";
import { popupEvent } from "../modal.templates";
import i18next from "i18next";

/**
 * Редактирование исключение по id (расширение ExceptionModal class)
 * @class EditEventExceptionModal
 * @extends ExceptionModal
 * @classdesc EditEventExceptionModal
 * */
export class EditEventExceptionModal extends ExceptionModal {
  excludeEdit: IExclude; // Исключение для редактирования

  constructor(rootID: string, root: MSCalendar) {
    super(rootID, root);
    super.init(getEditEventExceptionTemplate(), styles);
  }

  /**
   * Инициализация обработчиков событий
   */
  onStartup() {
    const modal = this.popup.modalComponent;

    modal.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;

      // Обработка кнопки "Добавить"
      if (target.closest("#submit")) {
        this.submit();
      }

      // Обработка кнопки "Сбросить"
      if (target.closest("#reset")) {
        this.close();
      }

      // Обработка кнопки "Удалить"
      if (target.closest("#delete")) {
        this.showDeleteConfirmationPopup(e);
      }
    });

    this.bodyEvents?.addEventListener("click", (e) => this.onClickEvent(e));
  }

  /**
   * Обработчик кнопки сохранения нового расписания
   * */
  submit() {
    if (!this.isValidForm()) return;
    if (!this.isValidPeriodForm()) return;

    const period = this.selectHelper.getFormValues();
    const excludeEvents: Array<IExclude> = JSON.parse(
      JSON.stringify(this.root.store.excludeSchedule)
    );

    const event = excludeEvents.find((x) => x.id === this.excludeEdit.id);

    if (event) {
      Object.assign(event, {
        ...event,
        ...this.eventsState[0],
        period,
        priority: Number(this.priority.value),
      });
    }

    this.store.onChange("excludeSchedule", excludeEvents);
    
    this.root.saveException();

    this.close();
  }

  /**
   * Показ попапа подтверждения удаления
   * @param {MouseEvent} e MouseEvent
   * @param {HTMLElement} row Строка события
   *
   */
  showDeleteConfirmationPopup(e: MouseEvent, row?: HTMLElement) {
    setTimeout(() => {
      const popover = new UiFloatPopover(
        popupEvent({
          title: i18next.t($ => $.scheduleBacnet.deletion),
          desc: i18next.t($ => $.scheduleBacnet.eventDeleteConfirmation),
        }),
        {
          x: e.clientX,
          y: e.clientY,
        }
      );

      popover.root.querySelector("#primary")?.addEventListener("click", () => {
        const excludeEvents: Array<IExclude> = JSON.parse(
          JSON.stringify(this.root.store.excludeSchedule)
        );
        const events = excludeEvents.filter(
          (x) => x.id !== this.excludeEdit.id
        );

        this.store.onChange("excludeSchedule", events);

        this.root.saveException();

        if (row) {
          row.remove();
        }
        popover.destroy();
        this.close();
      });

      popover.root
        .querySelector("#secondary")
        ?.addEventListener("click", () => popover.destroy());
    }, 0);
  }

  /**
   * Переключение видимости модального окна
   */
  toggle() {
    this.popup.modalComponent.toggle();
    if (!this.popup.modalComponent.active) return;
  }

  /**
   * Открытие модального окна
   */
  open(params?: any) {
    if (!params?.event) throw new Error("Ошибка редактирования: не найдено событие");

    this.excludeEdit = this.root.store.excludeSchedule?.find(
      ({ id }) => id === params?.event?.id
    );
    if (!this.excludeEdit) return;

    this.popup.modalComponent.open();

    this.resetForm();
    this.popup.uiModal.resetSize();

    // Заполнение данных о событии
    this.addEventTime({
      id: this.excludeEdit?.id,
      time: this.excludeEdit?.time,
      dataType: this.excludeEdit?.dataType,
      length: this.excludeEdit?.length,
      value: this.excludeEdit?.value,
    });

    // Установка приоритета
    this.priority.value = this.excludeEdit?.priority.toString();

    this.initPeriod(this.excludeEdit);
  }

  /**
   * Закрытие модального окна
   */
  close() {
    this.popup.modalComponent.close();
  }
}
